import { Center, Text, Title } from '@mantine/core';

export const ComingSoon = ({feature}:any) => {
    return       <Center style={{ width: "100%", height: "100%" }}>    <Title ml={8} order={1}>
    <Text pt={50} inherit  variant="gradient" component="span" gradient={{ from: 'pink', to: 'yellow' }} style={{fontWeight:700, letterSpacing: '4px'}}>
    {feature} - COMING SOON
  </Text><Text>We&apos;re still working on this feature, if you have any thoughts about what you&apos;d like to see, please get in touch!</Text></Title></Center>
}